module.exports = __webpack_public_path__ + "media/images/lb/636-94fe73b0d823cb849a84e08378ff201e.svg";